import React, { useState } from "react";
import BikeSell from "../images/sell-used-bike.png";
import Camera from "../images/camera-icon.svg";
import Bike from "../images/sell-bike.svg";
import Tag from "../images/tag.svg";
import DoneIcon from "@mui/icons-material/Done";
import { Box, Button, Modal } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import SeoMeta from "../components/meta";
import NumberLogin from "../components/loginModal/number";

const SellBikes = () => {
  const { user } = React.useContext(AuthContext);

  const history = useHistory();

  const navigateToBidding = () => {
    history.push("/sell-through-live-bidding");
  };

  const [isOpen, setIsOpen] = useState(false);

  const LoginOpen = () => {
    setIsOpen(true);
  };
  const LoginClose = () => {
    setIsOpen(false);
  };
  return (
    <>
      <SeoMeta
        title="Sell my bike online | Famewheels"
        desc="Famewheels, a trusted platform in Pakistan, offers post-bikes ads. Sell your bikes online from anywhere with ease, and it connects you with potential buyers quickly."
        url="used-bikes/sell"
      />

      <div className="adCategoryBg ">
        <div className="bg-white pb-5 mb-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="bike-main-content">
                  <h2 className="color-secondary text-center fw-700 fs-4">
                    Sell Your Bike Online in Pakistan Instantly!
                  </h2>

                  <div className="d-flex justify-content-center align-items-center flex-column mt-3">
                    <ul className="mt-3 saleSteps p-0">
                      <li className="gap-2">
                        <DoneIcon color="error" /> Post your Ad for Free in 3
                        Easy Steps
                      </li>
                      <li className="gap-2">
                        <DoneIcon color="error" /> Get Genuine offers from
                        Verified Buyers
                      </li>
                      <li className="gap-2">
                        <DoneIcon color="error" /> Sell your Bike Fast at the
                        Best Price
                      </li>
                    </ul>

                    <div className="w-75 mt-2">
                      {user ? (
                        <Link to="/used-bikes/post-ad?Free-Ads">
                          <Button
                            variant="contained"
                            fullWidth
                            className="bgSecondary text-white px-4 mt-4 fw-normal text-capitalize fw-600"
                          >
                            Post your Ad
                          </Button>
                        </Link>
                      ) : (
                        <Button
                          variant="conatined"
                          onClick={LoginOpen}
                          fullWidth
                          className="bgSecondary text-white px-4 mt-4 fw-normal text-capitalize fw-600"
                        >
                          Post Your Ad
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <img
                  src={BikeSell}
                  alt="Sell Used Bike"
                  className="img-fluid object-fit-contain w-100 rounded"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container py-3">
          <h4 className="fw-700">How to sell your bike quickly?</h4>
          <div className="row">
            <div className="col-lg-4">
              <div className="bg-white border rounded p-3 text-center bike-info-cards">
                <img
                  src={Camera}
                  alt="Camera"
                  className=" object-fit-contain w-10 rounded py-3"
                />
                <h5 className="fw-bold ">
                  Upload good quality, landscape photos
                </h5>
                <p>
                  Our data shows that ads with multiple photos have 90% more
                  views and faster selling rate.
                </p>
              </div>
            </div>
            <div className="col-lg-4 ">
              <div className="bg-white border rounded p-3 text-center bike-info-cards">
                <img
                  src={Bike}
                  alt="Camera"
                  className=" object-fit-contain w-10 rounded py-3"
                />
                <h5 className="fw-bold ">Feature your ad</h5>
                <p>
                  Feature your ad to bring it to the top. Ads with a featured
                  tag get sold 10 times faster.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="bg-white border rounded p-3 text-center bike-info-cards">
                <img
                  src={Tag}
                  alt="Camera"
                  className=" object-fit-contain w-10 rounded py-3"
                />
                <h5 className="fw-bold ">Setup realistic price</h5>
                <p>
                  Finding the right price for your bike is crucial. Set a
                  realistic and competitive price to attract potential buyers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={isOpen}
        onClose={LoginClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="sm-modal p-3 p-md-4">
          <div className="modalBody_area  px-2 ">
            <NumberLogin />
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default SellBikes;
